__turbopack_context__.v({
  "button": "CanadianBadge-module-scss-module__bQtQVG__button",
  "icon": "CanadianBadge-module-scss-module__bQtQVG__icon",
  "iconBlack": "CanadianBadge-module-scss-module__bQtQVG__iconBlack",
  "iconGreen": "CanadianBadge-module-scss-module__bQtQVG__iconGreen",
  "tooltip": "CanadianBadge-module-scss-module__bQtQVG__tooltip",
  "tooltipBubble": "CanadianBadge-module-scss-module__bQtQVG__tooltipBubble",
  "tooltipContent": "CanadianBadge-module-scss-module__bQtQVG__tooltipContent",
});
